/*
 *
 * ShelvesRibbon reducer
 *
 */

import ActionTypes from '../constants/selection';
import { SelectionState } from '../types';

export const initialState: SelectionState = {
  shelvesLevelSelected: [],
};

function shelvesRibbonReducer(
  state: SelectionState = initialState,
  action: any,
): SelectionState {
  switch (action.type) {
    case ActionTypes.SHELVES_SELECTION_SUCCESS:
      return { ...state, shelvesLevelSelected: action.payload.value };
    case ActionTypes.SHELF_SELECTION_CLEAR:
      return { ...state, shelvesLevelSelected: [] };
    default:
      return state;
  }
}

export default shelvesRibbonReducer;
